const traslado = (traslado) => ({
    id: traslado?.id || "",
    idTipoTraslado: traslado?.idTipoTraslado || "",
    idMotivoTraslado: traslado?.idMotivoTraslado || "",
    motivoNodiambula: traslado?.motivoNodiambula || "",
    telefonoAfiliado: traslado?.telefonoAfiliado || "",
    idCodigoTraslado: traslado?.idCodigoTraslado || "",
    conEspera: traslado?.conEspera || false,
    conRegreso: traslado?.conRegreso || false,
    accesorios: traslado?.accesorios || [],
    fechas: traslado?.fechas ? traslado?.fechas : [],
    observaciones: traslado?.observaciones || "",
    notasTraslado: traslado?.notasTraslado || [],
    direccionTraslado: direccionTraslado(traslado?.direccionTraslado),
    prestacionTraslado: prestacionTraslado(traslado?.prestacionTraslado),
  });
  
  const direccionTraslado = (direccion) => ({
    id: direccion?.id || "",
    idInstitucionDesde: direccion?.idInstitucionDesde || "",
    descripcionInstitucionDesde: direccion?.descripcionInstitucionDesde || "",
    direccionDesde: direccion?.direccionDesde || "",
    entreCallesDesde: direccion?.entreCallesDesde || "",
    localidadDesde: direccion?.localidadDesde || "",
    municipioDesde: direccion?.municipioDesde || "",
    provinciaDesde: direccion?.provinciaDesde || "",
    telefonoDesde: direccion?.telefonoDesde || "",
    idInstitucionHasta: direccion?.idInstitucionHasta || "",
    descripcionInstitucionHasta: direccion?.descripcionInstitucionHasta || "",
    direccionHasta: direccion?.direccionHasta || "",
    entreCallesHasta: direccion?.entreCallesHasta || "",
    localidadHasta: direccion?.localidadHasta || "",
    municipioHasta: direccion?.municipioHasta || "",
    provinciaHasta: direccion?.provinciaHasta || "",
    telefonoHasta: direccion?.telefonoHasta || "",
  });
  
  const prestacionTraslado = (prestacion) => ({
    idTipo: prestacion?.idTipo || "",
    institucion: prestacion?.institucion || "",
    practicaDiagnostico: prestacion?.practicaDiagnostico || "",
    practicaTerapeutica: prestacion?.practicaTerapeutica || "",
    profesional: prestacion?.profesional || "",
    especialidad: prestacion?.especialidad || "",
    fecha: prestacion?.fecha || null,
    hora: prestacion?.hora || null,
    cama: prestacion?.cama || "",
    idSector: prestacion?.idSector || "",
    practica: prestacion?.practica || null
  });

  const medico = (initMedico) => ({
    apellidoNombre: initMedico?.apellidoNombre || "",
    matriculaNac: initMedico?.matriculaNac || "",
    matriculaProv: initMedico?.matriculaProv || "",
    localidad: initMedico?.localidad || "",
    provincia: initMedico?.provincia || "",
    email: initMedico?.email || "",
    telefono: initMedico?.telefono || "",
  })
    
  export const initTrasladosValues = (tipoSolicitud, initValues) => ({
    id: initValues?.id || "",
    idEstado: initValues?.idEstado || "",
    idAfiliado: initValues?.idAfiliado || "",
    idTipoSolicitud: initValues?.idTipoSolicitud || tipoSolicitud.id,
    idPractica: initValues?.idPractica || "",
    idEfectorFacturacion: initValues?.idEfectorFacturacion || "",
    idTraslado: initValues?.idTraslado || "",
    idMedico: initValues?.idMedico || "",
    idDiagnostico: initValues?.idDiagnostico || "",
    afiliado: initValues?.afiliado || null,
    diagnostico: initValues?.diagnostico || null,
    efector: initValues?.efector || null,
    medico: medico(initValues?.medico),
    practica: initValues?.practica || null,
    documentacion: initValues?.documentacion || [],
    
    traslado: traslado(initValues?.traslado, initValues),

    ...(initValues?.usuarioAlta ? {
      usuarioAlta: initValues?.usuarioAlta,
      fechaAlta: initValues?.fechaAlta
    } : {})
  });

  // ENVIO DE DATA
  export const sendSolicitudValues = (formValues) => ({
    ...(formValues?.id ? {id: formValues?.id} : {}),
    idAfiliado: formValues?.idAfiliado,
    idTipoSolicitud: formValues?.idTipoSolicitud,
    idPractica: formValues?.idPractica,
    idEfectorFacturacion: formValues?.idEfectorFacturacion,
    idMedico: formValues?.idMedico,
    idDiagnostico: formValues?.idDiagnostico,
    idTraslado: formValues?.idTraslado,
    medico: formValues?.medico,
  });
  
  export const sendTrasladosValues = (formValues) => ({
    ...sendSolicitudValues(formValues),
    ...(formValues.traslado !== null ? {traslado: formValues.traslado} : {}),
  });